import React, { useState } from "react";
import { DataGrid, GridPagination } from "@mui/x-data-grid";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { Paper } from "@mui/material";
import { orderBy } from "lodash";
import { Box, Button, IconButton, Checkbox, Grid, Tooltip, Typography } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
	approveQuota,
	getPopupGraphData,
	getQuotaCustomerBreakdown,
	getQuotaForApproval,
	lockUnlockQuota,
	rejectQuota,
	setState,
} from "./quotaApprovalSlice";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import EditIcon from '@mui/icons-material/Edit';
import SmsIcon from "@mui/icons-material/Sms";
import { setState as setDefineState, GetScenarioforQuotaDefinition, GetUserCountries,
GetQuotaPeriodsfromNavigation, GetDepletionModels, reset, navigatedValues } from "../../Define/defineSlice";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import './QuotaApproval.css';

const OuterTable = ({ data }) => {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quota);
  const {
    quotaForApprovalTable, countries, selectedRows,selectedRowsselected,isCheckboxChecked,
  } = state;
  const [rowsSelected, setrowsSelected] = useState([]);
  const [IsAllSelect, setIsAllSelect] = useState(false);
  const {rows} = quotaForApprovalTable;
  //const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [orderByColumn, setOrderByColumn] = useState("");
  const [order, setOrder] = useState("asc");
  const handleRowClick = (params) => {
    if (params?.row?.quotaId != null) {
        const quotaId = params.row.quotaId;
        dispatch(setState("selectedQuotaid", quotaId));
        dispatch(getQuotaCustomerBreakdown({ quotaId }));
    }
  };
  useEffect(() => {
    setrowsSelected(selectedRowsselected.map((row) => row.id));
  }, selectedRowsselected);

  useEffect(() => {
    setrowsSelected([]);
    dispatch(setState("selectedRowsselected", []));
  },[]);

  useEffect(() => {
    debugger;
    if(isCheckboxChecked!==undefined){
if(!isCheckboxChecked){
  setrowsSelected([]);
  setIsAllSelect(false);
  dispatch(setState("selectedRowsselected", []));
}
    }
  }, [isCheckboxChecked]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckboxChange = (event, row) => {
    const rowId = row.id;
    let idx = selectedRowsselected.findIndex((x) => x.id === rowId);
    let isSelected = idx > -1;
    let selRows = [...selectedRowsselected];

    if (isSelected) {
      selRows = selRows.filter((x) => x.id !== rowId);
    } else {
      selRows.push(row);
    }
    if(selRows.length === 0){
      dispatch(setState("isCheckboxChecked", false));
    }
    else{
      dispatch(setState("isCheckboxChecked", true));
    }

    dispatch(setState("selectedRowsselected", selRows));
    dispatch(setState("selectedRows", selRows));
    setrowsSelected(selRows.map((row) => row.id));
    if (
      selRows.length === rows.filter((x) => x.canApproveReject === true).length
    ) {
      setIsAllSelect(true);
    } else {
      setIsAllSelect(false);
    }
  };
  const handleAllCheckboxChange = () => {
    if (!IsAllSelect) {
      let selRows = rows.filter((x) => x.canApproveReject === true);
      dispatch(setState("selectedRowsselected", selRows));
      dispatch(setState("selectedRows", selRows));
      dispatch(setState("isCheckboxChecked", true));
      setrowsSelected(selRows.map((row) => row.id));
      setIsAllSelect(true);
    } else {
      dispatch(setState("selectedRowsselected", []));
      dispatch(setState("selectedRows", []));
      setrowsSelected([]);
      setIsAllSelect(false);
      dispatch(setState("isCheckboxChecked", false));
    }
  };

  const handleRequestSort = (columnId) => {
    const isAsc = orderByColumn === columnId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderByColumn(columnId);
  };

  const paginatedData = orderBy(rows, orderByColumn, order).slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Grid className="quotas-table-container">
      <TableContainer style={{ maxHeight: "calc(100vh - 130px)" }}>
        <Table component={Paper} style={{ overflowY: "auto" }} stickyHeader>
          <TableHead
            sx={{
              "& th": {
                backgroundColor: "#EEF2F4!important",//"rgb(235, 245, 255)",
              },
            }}
            style={{ cursor: "pointer" }}
          >

<TableRow 
sx={{ 
  '& th, & td': { 
    borderBottom: 'none',
    // position: 'sticky',
    // top: 0,
    // zIndex: 3,
    // backgroundColor: "#EEF2F4!important"
  } 
}}>
    <TableCell colSpan={6}></TableCell>
    <TableCell sx={{ width: 10 }}></TableCell>
    <TableCell sx={{ width: 10 }}></TableCell>
    <TableCell sx={{ width: 10 }}></TableCell>
    <TableCell colSpan={4} align="center" sx={{borderLeft: '3px solid white'}}>From Scenario Set Up</TableCell>
    <TableCell colSpan={6} align="center" sx={{borderRight: '3px solid white',borderLeft: '3px solid white',borderBottom: '3px solid white',}}>From Define Quota Submission</TableCell>
    <TableCell colSpan={18}></TableCell> {/* Adjust based on remaining columns */}
  </TableRow>

            <TableRow 
            // sx={{
            //   '& th': {
            //     position: 'sticky',
            //     top: '40px', // Adjust based on the height of the first header row
            //     zIndex: 2,
            //     backgroundColor: "#EEF2F4!important"
            //   }
            // }}
            >
              <TableCell sx={{ width: 10, position: "sticky",top: '40px', left: 0, zIndex: 4, backgroundColor: "#EEF2F4" }}>
                <Checkbox
                  checked={IsAllSelect}
                  onChange={(e) => handleAllCheckboxChange()}
                />
              </TableCell>
              <TableCell onClick={() => handleRequestSort("depletionPeriodType")}
              sx={{ position: "sticky",top: '40px', left: 73, zIndex: 5, backgroundColor: "#EEF2F4", whiteSpace: 'nowrap', minWidth: 104 }}>
              Period Structure
              </TableCell>
              <TableCell onClick={() => handleRequestSort("scenarioName")}
              sx={{  position: "sticky",top: '40px', left: 184, zIndex: 5, backgroundColor: "#EEF2F4", minWidth: 104 }}>
                Scenario
              </TableCell>
              <TableCell onClick={() => handleRequestSort("geoId")}
              sx={{ position: "sticky",top: '40px', left: 275, zIndex: 5, backgroundColor: "#EEF2F4",whiteSpace: 'nowrap' }}>
                Country Code
              </TableCell>
              <TableCell onClick={() => handleRequestSort("criticalityId")}
              sx={{ position: "sticky",top: '40px', left: 359, zIndex: 7, backgroundColor: "#EEF2F4" }}>
              Criticality
              </TableCell>              
              <TableCell
              sx={{ position: "sticky",top: '40px', left: 455, zIndex: 5, backgroundColor: "#EEF2F4" }}>
                Graph</TableCell>
              <TableCell onClick={() => handleRequestSort("quotaStatus")}
              sx={{ position: "sticky",top: '40px', left: 552, zIndex: 5, backgroundColor: "#EEF2F4",whiteSpace: 'nowrap' }}>
                Quota Status
              </TableCell>
              <TableCell onClick={() => handleRequestSort("depletionModelName")} sx={{ whiteSpace: 'nowrap' }}>
              Time Depletion
              </TableCell>
              <TableCell onClick={() => handleRequestSort("initialForecast")} sx={{ whiteSpace: 'nowrap'}}>
              Forecast
              </TableCell>              
              <TableCell onClick={() => handleRequestSort("initialForecast_SetUp")} sx={{ whiteSpace: 'nowrap',borderLeft: '3px solid white',borderTop: '3px solid white',}}>
              Initial Quota
              </TableCell>
              <TableCell onClick={() => handleRequestSort("minQuota_SetUp")} sx={{ whiteSpace: 'nowrap',borderTop: '3px solid white', }}>
              Min Quota
              </TableCell>              
              <TableCell onClick={() => handleRequestSort("safetyMargin_SetUp")} sx={{ whiteSpace: 'nowrap',borderTop: '3px solid white', }}>
              Safety Margin
              </TableCell>
              <TableCell onClick={() => handleRequestSort("totalQuota_SetUp")} sx={{ whiteSpace: 'nowrap',borderTop: '3px solid white', }}>
              Total Quota
              </TableCell>   
              <TableCell onClick={() => handleRequestSort("initialForecast_Define")} sx={{ whiteSpace: 'nowrap',borderLeft: '3px solid white',borderTop: '3px solid white', }}>
              Initial Quota
              </TableCell>
              <TableCell onClick={() => handleRequestSort("minQuota_Define")} sx={{ whiteSpace: 'nowrap',borderTop: '3px solid white', }}>
              Min Quota
              </TableCell>
              <TableCell onClick={() => handleRequestSort("safetyMargin_Define")} sx={{ whiteSpace: 'nowrap',borderTop: '3px solid white', }}>
              Safety Margin
              </TableCell>
              <TableCell onClick={() => handleRequestSort("tender")} sx={{ whiteSpace: 'nowrap',borderTop: '3px solid white', }}>
              Tender
              </TableCell>
              <TableCell onClick={() => handleRequestSort("adjustment")} sx={{borderTop: '3px solid white',}}>
              Adjustment
              </TableCell>
              <TableCell onClick={() => handleRequestSort("totalQuota_Define")} sx={{ whiteSpace: 'nowrap',borderRight: '3px solid white',borderTop: '3px solid white', }}>
              Total Quota
              </TableCell>  
              <TableCell onClick={() => handleRequestSort("revisedQuota")} >
              Revised Quota
              </TableCell>  
              <TableCell onClick={() => handleRequestSort("previousTotalForecast")} sx={{ whiteSpace: 'nowrap' }}>
              Previous Total Quota
              </TableCell>  
              <TableCell onClick={() => handleRequestSort("difference")} sx={{ whiteSpace: 'nowrap' }}>
              Diff %
              </TableCell>                                                      
              <TableCell onClick={() => handleRequestSort("lastActionDate")} sx={{ whiteSpace: 'nowrap' }}>
                Last Action Date
              </TableCell>
              <TableCell onClick={() => handleRequestSort("lastActionBy")} sx={{ whiteSpace: 'nowrap' }}>
                Last Action By
              </TableCell>
              <TableCell onClick={() => handleRequestSort("period")} sx={{ whiteSpace: 'nowrap' }}>
              Period
              </TableCell>              
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Reject Quota</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Approve Quota</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Lock / Unlock</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Edit Quota</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData?.map((row, index) => (
              <React.Fragment key={row.id}>
                <TableRow>
                  <TableCell sx={{ width: 10, position: "sticky", left: 0, zIndex: 1, backgroundColor: "#EEF2F4" }}>
                    {row.canApproveReject && (
                      <Checkbox
                        checked={rowsSelected.includes(row.id)}
                        onChange={(e) => handleCheckboxChange(e, row)}
                      />
                    )}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}
                  sx={{ position: "sticky", top: 0, left: 73, zIndex: 2, backgroundColor: "#EEF2F4" }}>
                    <Tooltip
                      title={row.depletionPeriodTypeName || ""}
                      placement="top"
                      arrow
                      disableHoverListener={!row.depletionPeriodTypeName}
                    >
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{ lineHeight: 1.3, display: "inline-block" }}
                      >
                        {row.depletionPeriodType}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}
                  sx={{ position: "sticky",top:0, left: 184, zIndex: 2, backgroundColor: "#EEF2F4" }}>
                    {row.scenarioName}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}
                  sx={{ position: "sticky",top:0, left: 276, zIndex: 2, backgroundColor: "#EEF2F4" }}>
                    {
                      countries.find((c) => c.countryID === row.geoId)
                        .countryCode
                    }
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}
                  sx={{ position: "sticky",top:0, left: 359, zIndex: 2, backgroundColor: "#EEF2F4" }}>
                    <Criticality row={row} />
                  </TableCell >
                  <TableCell
                  sx={{ position: "sticky",top:0, left: 455, zIndex: 1, backgroundColor: "#EEF2F4" }}>
                    <ShowGraph row={row} />
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}
                  sx={{ position: "sticky",top:0, left: 552, zIndex: 1, backgroundColor: "#EEF2F4" }}>
                    {row.quotaStatus}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.depletionModelName}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.initialForecast?.toLocaleString('en-US')}
                  </TableCell>                    
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.initialForecast_SetUp?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.minQuota_SetUp?.toLocaleString('en-US')}
                  </TableCell>                                    
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.safetyMargin_SetUp?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.totalQuota_SetUp?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.initialForecast_Define?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.minQuota_Define?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.safetyMargin_Define?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.tender?.toLocaleString('en-US')}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.adjustment?.toLocaleString('en-US')}
                  </TableCell>  
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.totalQuota_Define?.toLocaleString('en-US')}
                  </TableCell>  
                  <TableCell onClick={() => handleRowClick({ row })}>
                    <RevisedQuota row={row} />
                  </TableCell>  
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.previousTotalForecast?.toLocaleString('en-US')}
                  </TableCell>  
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.difference?.toLocaleString('en-US')}
                  </TableCell>                 
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {" "}
                    {row.lastActionDate && (
                      <span>
                        {new Date(row.lastActionDate).toLocaleDateString(
                          "en-UK",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                      </span>
                    )}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.lastActionBy}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.period}
                  </TableCell>                  
                  <TableCell>
                    <RejectButton row={row} />
                  </TableCell>                
                  <TableCell>
                    <ApproveButton row={row} />
                  </TableCell>
                  <TableCell>
                    <LockUnlock row={row} />
                  </TableCell>  
                  <TableCell>
                    <EditQuota row={row} />
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 50, 100]}
        component="div"
        count={rows?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end", // Align pagination to the right
          paddingRight: "16px", // Add some padding to prevent overlap
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
};


function ShowGraph(params) {
  const dispatch = useDispatch();

  function getPopupData() {
    const obj = {
      scenarioID: params.row.scenarioId,
    };
    dispatch(getPopupGraphData(obj));
    dispatch(setState("graphModalOpen", true));
  }

  return (
		<Button className="closeButton2" 
		style={{fontSize:"0.85rem"}}
		sx={{
			color: "#FFFFFF", 
			backgroundColor: "darkred.light",
			width: "80px !important", 
			height: "32px", 
			textTransform: "none",
			borderRadius: "4px", 
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			"&:hover": {
				backgroundColor: "darkred.main",
				color:"#FFFFFF" 
			},
		}}
		 onClick={getPopupData}>Details</Button>
	);
}
function RejectButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	function openRejectModal() {
		dispatch(setState("selectedQuotaid", params.row.quotaId));
		dispatch(setState("rejectSingleModalOpen", true));
	}

	if (params.row.canApproveReject && isRestrictedAccess) {
		return (
			<IconButton onClick={openRejectModal}>
				<CancelIcon sx={{ color: "red.main" }} />
			</IconButton>
		);
	}
	return null;
}

function Criticality(params) {

	const colors = [
		{ id: 5, color: "blue.main" },
		{ id: 4, color: "black.main" },
		{ id: 3, color: "red.main" },
		{ id: 2, color: "orange.main" },
		{ id: 1, color: "green.main" },
	];

	const CriticalityDesc = [
		{ id: 5, desc: "Other" },
		{ id: 4, desc: "Severe" },
		{ id: 3, desc: "High" },
		{ id: 2, desc: "Medium" },
		{ id: 1, desc: "Low" },
	]
	const Desc = CriticalityDesc.find(c => c.id === params.row.criticalityId).desc;
	const color = colors.find(c => c.id === params.row.criticalityId).color;
	return (
		<Box>
			<Tooltip title={Desc}>
				<CircleIcon sx={{ color: color }} />
			</Tooltip>
		</Box>
	);
}

function LockUnlock(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quota);
	const { quotaForApproval, selectedCountryID, selectedPeriod, selectedQuotaStatus, searchText } = state;

	function lockUnlock() {
		const id = params.row.quotaId;
		const quota = quotaForApproval.find(item => item.quotaId === id);
		const user = JSON.parse(localStorage.getItem("data"));
		const obj = {
			...quota,
			user,
		};
		console.log("Approval_Quota_LockUnlock", obj);
		dispatch(lockUnlockQuota(obj)).then(() => {
			search();
		});
	}

	function search() {
    debugger;
		dispatch(setState("quotaCustomerBreakdown", null));
		dispatch(setState("quotaDetailsTable", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("selectedRows", []));
    dispatch(setState("isCheckboxChecked", false));
        // setrowsSelected([]);
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const countryId = selectedCountryID;
		const period = selectedPeriod;
		const quotaStatus = selectedQuotaStatus;

		const obj = {
			countryId,
			period,
			quotaStatus,
			logedUser,
			searchText: searchText
		};
		dispatch(getQuotaForApproval(obj));
	}
	if (isRestrictedAccess) {
		return (
			<IconButton onClick={lockUnlock}>
				{
					params.row.isSubmitLocked ?
						<LockIcon 
						sx={{ 
							color: "black.main" ,
							"&:hover": {
								color: "darkred.light",
								},
						}} /> :
						<LockOpenIcon 
						sx={{ 
							color: "black.main" ,
							"&:hover": {
								color: "darkred.light",
								},
						}} />
				}
			</IconButton>
		);
	}
}

function ApproveButton(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const state = useSelector((store) => store.quota);
	const {
		quotaForApproval,
		selectedCountryID,
		selectedPeriod,
		selectedQuotaStatus,
		searchText
	} = state;

	function search() {
		dispatch(setState("quotaCustomerBreakdown", null));
		dispatch(setState("quotaDetailsTable", null));
		dispatch(setState("rejectSelectedComment", ''));
		dispatch(setState("selectedRows", []));
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const countryId = selectedCountryID;
		const period = selectedPeriod;
		const quotaStatus = selectedQuotaStatus;

		const obj = {
			countryId,
			period,
			quotaStatus,
			logedUser,
			searchText: searchText
		};
		dispatch(getQuotaForApproval(obj));
	}

	function preparePayload() {
		const quota = quotaForApproval.find(
			(quota) => quota.quotaId === params.row.quotaId
		);
		console.log(quota);
		const user = JSON.parse(localStorage.getItem("data"));
		console.log(user);
		const obj = {
			...quota,
			user: user,
		};
		const country = user.userCountries.find(
			(index) => index.country.countryID === quota.geoId
		).country;
		console.log(country);

		return obj;
	}

	function approve() {
		const obj = preparePayload();
		dispatch(approveQuota(obj)).then(() => {
			search();
      dispatch(setState("isCheckboxChecked", false));
		});
	}

	function approvewithComments() {
		const obj = preparePayload();
		dispatch(setState("selectedQuotaid", obj.quotaId));
		dispatch(setState("approveSingleWithCommentsModalOpen", true));
	}

	if (params.row.canApproveReject && isRestrictedAccess) {
		return (
			<div>
				<IconButton onClick={approve}>
					<CheckCircleIcon sx={{ color: "green.main" }} />
				</IconButton>
				<IconButton onClick={approvewithComments}>
					<SmsIcon sx={{  }} />
				</IconButton>
			</div>
		);
	}
	return null;
}

function RevisedQuota(params) {
	const dispatch = useDispatch();
	function removeComma(str) {
		let formattedString = "";
		for (let i = 0; i < str.length; i++) {
			if (str[i] !== ",") {
				formattedString += str[i];
			}
		}
		return formattedString;
	}

	const scenarioApprovalState = useSelector((store) => store.quota);
	const { quotaForApproval, quotaForApprovalTable } = scenarioApprovalState;
	function updateRevisedQuota(event) {
		let RevisedQuota = Number(removeComma(event.target.value));


		if (!RevisedQuota && RevisedQuota !== 0) {
			return;
		}
		let RowTable = JSON.parse(JSON.stringify(quotaForApprovalTable));
		let index = RowTable.rows.findIndex((x) => x.quotaId === params.row.quotaId);
		RowTable.rows[index].revisedQuota = RevisedQuota;
		dispatch(setState("quotaForApprovalTable", RowTable));

		let Row = JSON.parse(JSON.stringify(quotaForApproval));
		let index1 = Row.findIndex((x) => x.quotaId === params.row.quotaId);
		Row[index1].revisedQuota = RevisedQuota;
		dispatch(setState("quotaForApproval", Row));
	}

	return (
		<TextField
			variant="standard"
			value={params.row.revisedQuota?.toLocaleString('en-US')}
			onChange={updateRevisedQuota}
			onClick={(event)=>event.stopPropagation()}
			sx={{ width: 100 }}
		/>
	);
}

function EditQuota(params) {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const scenarioApprovalState = useSelector((store) => store.quota);
	const { quotaForApproval, countries, selectedRows } = scenarioApprovalState;
	const DefineState = useSelector((store) => store.define);
	const { navigatedCountryId, navigatedScenarioId } = DefineState;

	function gotoEditScenario() {
		const id = params.row.quotaId;
		const quota = quotaForApproval.find((s) => s.quotaId === id);
		const { scenarioName, effectiveStartDate, effectiveEndDate } = quota;
		dispatch(setDefineState("isNavigate", true));
		// #endregion
		navigate("/define/quota");
		let obj = {
			countryID: quota.geoId,
			selectedCountry: countries.find((country) => country.countryID === quota.geoId),
			scenarioID: quota.scenarioId
		}

		// #region Set quota Values
		dispatch(setDefineState("navigatedCountryId", quota.geoId));
		dispatch(setDefineState("navigatedScenarioId", quota.scenarioId));
		dispatch(GetUserCountries({ method: "Get" })).then(() => {
			dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: quota.geoId })).then(() => {
				dispatch(GetQuotaPeriodsfromNavigation({ method: "GET", scenarioID: quota.scenarioId })).then(() => {
					dispatch(GetDepletionModels({ method: "GET" })).then(() => {
						dispatch(navigatedValues(obj));
					});
				});
			});
		})

	}

	if (isRestrictedAccess) {
		return (
			<IconButton 
			sx={{
				padding:0,
				'&:hover':{
						 backgroundColor:'#F8E9E7',
						 borderRadius:'2px',
					  }
			 }}
			>
				{
					params.row.isSubmitLocked ?
						"" :
						<EditIcon onClick={gotoEditScenario} 
						sx={{ 
							color: "#000000",
							fontSize:'large', 
							justifyContent: 'center',
							borderRadius:'2px',
							width:25,
							height:22,
							backgroundColor: 'transparent',
							}} />
				}
			</IconButton>
		);
	} else {
		return null;
	}
}

// Example usage:
const App = () => {
  const outerData = [];

  return <OuterTable data={outerData} />;
};

export default App;
